export default class ThemeHelperFactory {
    GetThemeHelper(umUrl, themeCallback = null) {
        return new ThemeHelper(umUrl, themeCallback);
    }
}